<template>
  <div id="app" class="app__background">
    <header class="header">
      <router-link :to="{ name: 'splash' }" class="logo--avrotros">
        AVROTROS
      </router-link>
      <router-link :to="{ name: 'splash' }" class="logo--radioring">
        RadioRing
      </router-link>
    </header>
    <router-view v-if="loaded" />
    <p v-else-if="offline" v-html="offlineDescription" class="p--md" style="text-align: center" />
    <loader v-else />
  </div>
</template>

<script>
import Loader from './components/Loader'
import { get } from './util/request'
import { SORT_ASC, SORT_RANDOM } from './sortTypes'
const { CDN_DOMAIN } = process.env

export default {
  name: 'app',
  components: {
    loader: Loader
  },
  computed: {
    loaded() {
      return this.$store.state.loaded
    },
    offline() {
      return this.$store.state.offline
    },
    offlineDescription() {
      return this.$store.state.frontend.offline_description ?
        this.$store.state.frontend.offline_description :
        'Er kan momenteel niet gestemd worden.'
    }
  },
  mounted() {
    get(`frontend`)
      .then(async response => await response.json())
      .then(response => {
        const data = response.data
        const imageSrc = data.image ? data.image.data.src : null
        const seoImageSrc = data.seoImage ? data.seoImage.data.src : null

        const frontend = {
          description: data.description,
          offline_description: data.offline_description,
          image: imageSrc ? CDN_DOMAIN + imageSrc : null,
          seoName: data.seoName,
          seoDescription: data.seoDescription,
          seoImage: seoImageSrc ? CDN_DOMAIN + seoImageSrc : null
        }
        this.$store.dispatch('setFrontend', frontend)
      })

    get(`voting/round`)
      .then(async response => await response.json())
      .then(response => {
        const round = response.data

        if (!round) {
          this.$store.dispatch('setOffline', true)
          return
        }
        this.$store.dispatch('setAllowSuggestions', round.allow_suggestions && round.suggestions_max > 0)
        const categoriesOrderedByName = Object.values(round.categories.data || {})
          .map(({ id, name }) => {
            return {
              id: Number(id),
              name: name,
              slug: name.replace(' ', '-').toLowerCase(),
              sortType: SORT_RANDOM,
              selectedChannelId: null,
              selectedDayPartId: null,
              keyword: ''
            }
          })
          .sort((a, b) => a.name.localeCompare(b.name))

        const categoryId = categoriesOrderedByName.map(obj => obj.id).reverse()

        const categoriesOrderedById = categoryId
          .map(id => categoriesOrderedByName.find(category => category.id === id))
          .filter(x => x)

        const categories =
          categoriesOrderedById.length === 3 ? categoriesOrderedById : categoriesOrderedByName

        const categoriesArray = categories.map(obj => obj.id);

        let stationsTags = categoriesArray.reduce((acc, num) => {
          acc[num] = [];
          return acc
        }, {});

        const nominees = Object.values(round.nominees.data || {}).map(nominee => {
          const imageSrc = nominee.image ? nominee.image.data.src : null
          const imageThumnb = nominee.image ? nominee.image.data.src : null

          if(categoriesArray.includes(nominee.category_id)) {
            if(nominee.zender1 !== null){
              stationsTags[nominee.category_id].push(nominee.zender1);
            }
            if(nominee.zender2 !== null){
              stationsTags[nominee.category_id].push(nominee.zender2);
            }
          }

          const showtimesKeys = ['ochtend', 'middag', 'avond', 'nacht', 'weekend']
          const showtimesKeyMapping = {
            o: 'ochtend',
            m: 'middag',
            a: 'avond',
            n: 'nacht',
            w: 'weekend'
          }
          const showtimes = Object.entries(nominee)
            .filter(
              ([key, value]) =>
                showtimesKeyMapping[key] && value !== 0 && showtimesKeys.includes(showtimesKeyMapping[key])
            )
            .map(([key]) => ({ [showtimesKeys.indexOf(showtimesKeyMapping[key])]: showtimesKeyMapping[key] }))

          return {
            id: nominee.id,
            name: nominee.name,
            slug: nominee.name
              .replace(/[^a-zA-Z ]/g, '')
              .toLowerCase()
              .replace(/ /g, '-'),
            secondaryName: nominee.secondary_name,
            categoryId: nominee.category_id,
            combinedName: nominee.combined_name,
            image: imageSrc ? CDN_DOMAIN + imageSrc.replace('//d2gg2n9hjjjmhb.cloudfront.net/', '') : null,
            imageThumb: imageThumnb
              ? CDN_DOMAIN + imageThumnb.replace('//d2gg2n9hjjjmhb.cloudfront.net/', '')
              : null,
            stations: [nominee.zender1, nominee.zender2].filter(item => item !== null && item !== ''),
            broadcaster: nominee.omroep,
            showtimes: showtimes
          }
        })
        categoriesArray.forEach(property => {
          stationsTags[property] = [...new Set(stationsTags[property])].filter(
            item => item !== null && item !== ''
          )
        })
        this.$store.dispatch('setStationsTags', stationsTags)
        this.$store.dispatch('setRounds', round)
        this.$store.dispatch('setCategories', categories)
        this.$store.dispatch('setNominees', nominees)
        this.$store.dispatch('setLoaded', true)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue